import { Flex, Text, Grid, GridItem } from '@chakra-ui/react';
import React, { Component } from 'react';
import TabChart from './dashboard/tabChart';
import TaskList from './dashboard/taskList';
import TabularCard from './dashboard/tabularCard';
import Overview from './costs/overviewCard';
import isEqual from 'lodash/isEqual';
import {
  FaArrowDown,
  FaArrowUp,
  FaThumbsDown,
  FaThumbsUp,
} from 'react-icons/fa';
import BenchmarkOW from './benchmark/benchmarkOverview';
import BenchmarkTable from './benchmark/benchmarkTable';
import TaskManager from './tasks/taskAdder';
import SettingPage from './settings/settingsPage';
import 'rsuite/dist/rsuite.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import LocationDropDown from '../utility/location';
import HotglueConfig from '@hotglue/widget';
import '../widgets/drawer.css';
import UploadPage from './uploadData/uploadData';
import Profile from './profile/profileData';
import PLSummary from './costs/plSummary';
import apiEndpoint from '../config/data';
import { fetchWithAuth } from '../../utils/apiHelpers';
import getHotglueConfig from '../config/hotglue';
import ComparatorTable from './comparator/main';
import DateAnalysis from './comparator/dateAnalysis';
import ReskinnedCost from '../cost/reskinnedCost';
import { connect } from 'react-redux';
import ManageUsers from '../manageUsers/manageUsers';
import SubscriptionBilling from '../subscription/SubscriptionBilling';
import ManageRoles from '../manageRoles/manageRoles';
import {
  setPeriodFrom,
  setPeriodSelect,
  setPeriodTo,
} from '../../redux/slices/dateSlice';
import { setDataLoading } from '../../redux/slices/dataFetchSlice';
import AuthorisationSettings from './settings/settingsAuthorisation';
import SettingBudget from './settings/settingBudget';
import PLSummarySetting from './settings/plSumSetting';
import IntegrationSettingHook from './settings/settingsIntegrationsHook';
import DefineRoleSettings from './settings/defineRoleSetting';
import DefinePrivSettings from './settings/definePrivSetting';
import DefineExclusionSettings from './settings/defineExclusionSettings';
import DefineExclusionSettingsNew from './settings/defineExclusionSettingsNew';
import AIMonthSummary from './aiSummary/aiMonthSummary';
import AISummaryOneDemand from './aiSummary/aiSummary_ondemand';
import CorporateSummary from './corporate/corporateSummary';
import SettingBudgetDrillDown from './settings/settingBudgetDrillDown';
import BudgetDashboard from './budgetDDDashboard/budgetDashboard';
import LocationBaseAISummary from './settings/locationBaseAISummary';
import { HeadingText } from '@spotoninc/nexus-react';
import { tokensLight as tokens } from '@spotoninc/nexus-design-tokens/js/tokens-light';
import LocationAnalysis from '../financialInsights/locationAnalysis';
import ComparisonOvertime from '../financialInsights/comparisonOvertime';
import ManageAliasAndClassification from '../manageAliasAndClassification/manageAliasAndClassification';
import ManagePrivilege from '../managePrivilege/managePrivilege';
import ManageExclusions from '../manageExclusions/manageExclusions';
import ManageBudget from '../manageBudget/manageBudget';
import CustomLocationSelector from '../utility/customLocationSelector';
import size from 'lodash/size';

const Dashboard = props => {
  const [winsSortState, setWinsSortState] = React.useState(null);
  const [lossesSortState, setLossesSortState] = React.useState(null);
  const [showOnlyTenWins, setShowOnlyTenWins] = React.useState(true);
  const [showOnlyTenLosses, setShowOnlyTenLosses] = React.useState(true);
  const [periodEnabled, setPeriodEnabled] = React.useState(false);
  const [currentLocation, setCurrentLocation] = React.useState(1);

  const handleSortChange = (stateSetter, column) => {
    stateSetter(prevState => ({
      column,
      direction:
        prevState?.column === column && prevState.direction === 'asc'
          ? 'desc'
          : 'asc',
    }));
  };

  // When showReskin is false, use the original Flex layout
  if (!(props.flags && props.flags.showReskin)) {
    return (
      <>
        <Flex
          gap={4}
          flexWrap={'wrap'}
          maxH={'100%'}
          flexDirection={{ base: 'column', xl: 'row' }}
        >
          <Flex
            flex={{ base: 1, lg: 3 }}
            width="100%"
            maxW="100%"
            overflow="hidden"
            minW={0}
          >
            <TabChart
              income={props.income}
              expense={props.expense}
              revenue={props.revenue}
              dateValue={props.dateValue}
              value={props.value}
              locationValue={props.locationValue}
              setLocation={props.setLocation}
            />
          </Flex>
          <Flex
            flex={{ lg: 1, xl: 2 }}
            width="100%"
            maxW="100%"
            overflow="hidden"
            minW={0}
            minH={'18.75rem'}
          >
            <TaskList onClick={props.clickThru} />
          </Flex>
        </Flex>
        <Flex
          gap={4}
          justifyContent={'center'}
          flexWrap={'wrap'}
          flexDirection={{ base: 'column', lg: 'row' }}
        >
          <Flex flex={1} width={{ base: '100%', lg: 'auto' }}>
            <TabularCard
              header="Wins"
              headerColumnText="Wins"
              bgColor={'lightgreen'}
              icon={FaArrowDown}
              headerIcon={FaThumbsUp}
              data={props.wins || []}
              clickThru={props.clickThru}
              sortState={winsSortState}
              onSortChange={column =>
                handleSortChange(setWinsSortState, column)
              }
              showOnlyTen={showOnlyTenWins}
              toggleShowOnlyTen={() => setShowOnlyTenWins(prev => !prev)}
            />
          </Flex>
          <Flex flex={1} width={{ base: '100%', lg: 'auto' }}>
            <TabularCard
              header="Losses"
              headerColumnText="Losses"
              bgColor={'#f79d97'}
              icon={FaArrowUp}
              headerIcon={FaThumbsDown}
              data={props.losses || []}
              clickThru={props.clickThru}
              sortState={lossesSortState}
              onSortChange={column =>
                handleSortChange(setLossesSortState, column)
              }
              showOnlyTen={showOnlyTenLosses}
              toggleShowOnlyTen={() => setShowOnlyTenLosses(prev => !prev)}
            />
          </Flex>
        </Flex>
      </>
    );
  }

  // When showReskin is true, use Grid layout for better responsiveness
  return (
    <>
      {/* Header Section with Overview title and LocationDropDown */}
      <Grid
        templateColumns={{ base: '1fr', md: '1fr 1fr' }}
        gap={{ base: 4, md: 6 }}
        mb={{ base: 4, md: 6 }}
        alignItems="center"
      >
        <GridItem colSpan={{ base: 1, md: 1 }}>
          <HeadingText fontSize={{ base: '1.5rem', md: '1.75rem' }}>
            Overview
          </HeadingText>
        </GridItem>
        <GridItem
          colSpan={{ base: 1, md: 1 }}
          justifySelf={{ base: 'start', md: 'end' }}
        >
          <CustomLocationSelector
            locationValue={props.locationValue}
            setLocation={props.setLocation}
          />
        </GridItem>
      </Grid>

      {/* Main Content Section - Charts and Tasks */}
      <Grid
        templateColumns={{ base: '1fr', xl: '3fr 1fr' }}
        gap={{ base: 5, md: 4 }}
        mb={{ base: 5, md: 4 }}
      >
        <GridItem
          colSpan={1}
          minH={{ base: '300px', md: 'auto' }}
          mb={{ base: 4, md: 0 }}
          overflow="hidden"
        >
          <TabChart
            income={props.income}
            expense={props.expense}
            revenue={props.revenue}
            dateValue={props.dateValue}
            value={props.value}
            locationValue={props.locationValue}
            setLocation={props.setLocation}
          />
        </GridItem>
        <GridItem
          colSpan={1}
          minH={{ base: '300px', md: '18.75rem' }}
          overflow="hidden"
        >
          <TaskList onClick={props.clickThru} />
        </GridItem>
      </Grid>

      {/* Wins & Losses Section Header */}
      <Grid
        templateColumns="1fr"
        mb={{ base: 3, md: 2 }}
        mt={{ base: 4, md: 6 }}
      >
        <GridItem>
          <Text
            style={{
              color: tokens.semanticColorTextNeutralStrongestNone,
              fontFamily: tokens.primitiveFontFamilySans,
              fontSize: tokens.primitiveFontSize300,
              fontWeight: tokens.primitiveFontWeightSemibold,
              lineHeight: tokens.primitiveFontLineHeight200,
              letterSpacing: tokens.primitiveFontLetterSpacingDefault,
              verticalAlign: 'middle',
            }}
            className="financial-summary-title"
            whiteSpace="nowrap"
          >
            Wins & Losses
          </Text>
        </GridItem>
      </Grid>

      {/* Wins & Losses Cards */}
      <Grid
        templateColumns={{ base: '1fr', lg: 'repeat(2, 1fr)' }}
        gap={{ base: 5, md: 4 }}
      >
        <GridItem minH={{ base: '300px', md: 'auto' }}>
          <TabularCard
            header="Wins"
            headerColumnText="Wins"
            bgColor={'lightgreen'}
            icon={FaArrowDown}
            headerIcon={FaThumbsUp}
            data={props.wins || []}
            clickThru={props.clickThru}
            sortState={winsSortState}
            onSortChange={column => handleSortChange(setWinsSortState, column)}
            showOnlyTen={showOnlyTenWins}
            toggleShowOnlyTen={() => setShowOnlyTenWins(prev => !prev)}
          />
        </GridItem>
        <GridItem minH={{ base: '300px', md: 'auto' }}>
          <TabularCard
            header="Losses"
            headerColumnText="Losses"
            bgColor={'#f79d97'}
            icon={FaArrowUp}
            headerIcon={FaThumbsDown}
            data={props.losses || []}
            clickThru={props.clickThru}
            sortState={lossesSortState}
            onSortChange={column =>
              handleSortChange(setLossesSortState, column)
            }
            showOnlyTen={showOnlyTenLosses}
            toggleShowOnlyTen={() => setShowOnlyTenLosses(prev => !prev)}
          />
        </GridItem>
      </Grid>
    </>
  );
};

const Cost = props => {
  return (
    <>
      <Flex flex={1}>
        <Overview
          revenue={props.costRevenue}
          cost={props.cost}
          income={props.costIncome}
          handleDate={props.dateValue}
          value={props.value}
          locationValue={props.locationValue}
          setLocation={props.setLocation}
        />
      </Flex>
      <Flex justifyContent={'center'} flex={1}>
        <PLSummary
          pltable={props.pltableSum}
          columns={props.columnsSum}
          from_date={props.from_date}
          to_date={props.to_date}
          tableData={props.tableData}
          locationValue={props.locationValue}
          highlightDesc={props.highlightDesc}
        />
      </Flex>
    </>
  );
};

const Budget = props => {
  return (
    <>
      <Flex flex={1}>
        <BudgetDashboard
          series={props.series}
          categories={props.categories}
          targetRevenue={props.targetRevenue}
          targetExpense={props.targetExpense}
          achievedRevenue={props.achievedRevenue}
          achievedExpense={props.achievedExpense}
          clickThru={props.clickThru}
          handleLocationChange={props.handleLocationChange}
          handleDateChange={props.handleDateChange}
          location={props.location}
          dateValue={props.dateValue}
        />
      </Flex>
    </>
  );
};

const Benchmark = props => {
  return (
    <Flex direction="column" width="100%">
      <BenchmarkOW
        overview={props.overview}
        handleDate={props.dateValue}
        value={props.value}
        locationValue={props.locationValue}
        setLocation={props.setLocation}
      />
      <BenchmarkTable
        table={props.table}
        clickThru={props.clickThru}
        callTable={props.callTable}
      />
    </Flex>
  );
};

const TaskPage = () => {
  return (
    <>
      <TaskManager />
    </>
  );
};

class WidgetDrawer extends Component {
  state = {
    analysisLocation: [],
    wlData: {
      wins: [],
      losses: [],
    },
    plTableExcel: [],
    revenue: [
      {
        data: [],
        series: [],
        categories: [],
      },
    ],
    expense: [
      {
        data: [0],
        series: [0],
        categories: [0],
      },
    ],
    income: [
      {
        data: [0],
        series: [0],
        categories: [0],
      },
    ],
    costRevenue: { value: 0 },
    costIncome: { value: 0 },
    cost: { value: 0 },
    pltable: [],
    pltableSum: [],
    dashboardLocation: '',
    costLocation: '',
    benchmarkLocation: '',
    budgetLocation: '',
    defaultBenchmarkValue: this.props.defaultDateValue,
    dashboardDate: this.props.defaultDateValue,
    costDate: this.props.defaultDateValue,
    defaultCostValue: this.props.defaultDateValue,
    budgetDate: this.props.defaultDateValue,
    benchmarkDate: this.props.defaultDateValue,
    corporateDate: this.props.defaultDateValue,
    // Add date-related state properties
    costsFromDate: '',
    costsToDate: '',
    selectedCountry: null, // To store selected country
    corporateData: {}, // Corporate data state
    benchmarkDataTable: [], // Add missing state properties
    benchmarkOverview: {},
  };

  // Helper method to get location value for multi-select pages
  getLocationValueForMultiSelect = () => {
    // If analysisLocation is already an array with values, use it
    if (
      Array.isArray(this.state.analysisLocation) &&
      this.state.analysisLocation.length > 0
    ) {
      return this.state.analysisLocation;
    }

    // If we have a single location from other pages, convert it to array
    const singleLocation = this.getCurrentSingleLocation();
    return singleLocation ? [singleLocation] : [];
  };

  // Helper method to get the current single location
  getCurrentSingleLocation = () => {
    return (
      this.state.costLocation ||
      this.state.dashboardLocation ||
      this.state.benchmarkLocation ||
      ''
    );
  };

  // Helper method to update all location states
  updateAllLocationStates = (singleLocation, multiLocation = null) => {
    const updates = {
      dashboardLocation: singleLocation,
      costLocation: singleLocation,
      benchmarkLocation: singleLocation,
      budgetLocation: singleLocation,
    };

    if (multiLocation !== null) {
      updates.analysisLocation = multiLocation;
    } else {
      updates.analysisLocation = singleLocation ? [singleLocation] : [];
    }

    return updates;
  };

  // Helper method to handle multi-select location changes
  handleMultiSelectLocationChange = value => {
    const updates = {
      analysisLocation: value,
    };

    // Also update single-select locations with the first selected location
    if (Array.isArray(value) && value.length > 0) {
      updates.dashboardLocation = value[0];
      updates.costLocation = value[0];
      updates.benchmarkLocation = value[0];
      updates.budgetLocation = value[0];
    }

    return updates;
  };

  // Helper method to compare data objects and determine if an update is needed
  shouldUpdateData = (newData, oldData) => {
    // If either is undefined, only update if they're different
    if (newData === undefined || oldData === undefined) {
      return newData !== oldData;
    }

    // For arrays, compare length as a quick check
    if (Array.isArray(newData) && Array.isArray(oldData)) {
      if (newData.length !== oldData.length) return true;
    }

    // For objects and arrays, use Lodash's isEqual for efficient deep comparison
    if (
      (Array.isArray(newData) && Array.isArray(oldData)) ||
      (typeof newData === 'object' && typeof oldData === 'object')
    ) {
      return !isEqual(newData, oldData);
    }

    // For primitive values, direct comparison
    return newData !== oldData;
  };

  calenderPropsDateConverter = value => {
    const val = [];
    if (value !== undefined) {
      // Use forEach instead of map since we're not returning anything
      value.forEach(item => {
        val.push(new Date(new Date(item).toString()));
      });
    }
    return val;
  };

  handleBudgetDate = value => {
    // Don't call API if we don't have location data yet
    const hasLocationData =
      this.state.dashboardLocation ||
      this.state.costLocation ||
      this.state.benchmarkLocation;

    if (!hasLocationData) {
      console.log(
        'Skipping budget date fetch - no location data available yet'
      );
      return;
    }

    var fromDate =
      (value[0].getMonth() > 8
        ? value[0].getMonth() + 1
        : '0' + (value[0].getMonth() + 1)) +
      '-' +
      (value[0].getDate() > 9 ? value[0].getDate() : '0' + value[0].getDate()) +
      '-' +
      value[0].getFullYear();
    var toDate =
      (value[1].getMonth() > 8
        ? value[1].getMonth() + 1
        : '0' + (value[1].getMonth() + 1)) +
      '-' +
      (value[1].getDate() > 9 ? value[1].getDate() : '0' + value[1].getDate()) +
      '-' +
      value[1].getFullYear();

    var formData = new FormData();
    formData.append('fromDate', fromDate);
    formData.append('toDate', toDate);
    // Include location/integration when available to satisfy backend params
    {
      let location =
        this.state.costLocation || this.state.dashboardLocation || '';
      let integrationId = '';
      if (
        typeof location === 'string' &&
        location.startsWith('INTEGRATION::')
      ) {
        integrationId = location.split('::')[1] || '';
        location = '';
      } else if (typeof location === 'string' && location.includes('|')) {
        const parts = location.split('|');
        if (parts.length > 1) integrationId = parts[1];
      }
      formData.append('location', location || '');
      if (integrationId) formData.append('integration', integrationId);
    }

    fetchWithAuth('/api/overview_data/', {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        const budget = data['budget_bar'];

        const budgetSeries = [
          {
            name: data['budget_bar']['series'][0],
            data: data['budget_bar']['data'][0]['total'][0],
          },
          {
            name: data['budget_bar']['series'][1],
            data: data['budget_bar']['data'][0]['target'][0],
          },
        ];

        const budgetCategories = data['budget_bar']['categories'];
        this.setState({
          budget: budget,
          budgetSeries: budgetSeries,
          budgetCategories: budgetCategories,
        });
        this.setState({
          revenue: data['revenue'],
          expense: data['expense'],
          income: data['income'],
        }); //, income: data['income'], cost: data['expense'] })
        const wlData = data['wlData'];
        this.setState({ wlData: wlData });
        this.setState({ defaultDashValue: value });
      })
      .catch(err => console.error(err));
  };

  // Helper function to convert Date object to MM-DD-YYYY format
  formatDateToMMDDYYYY = dateObj => {
    if (!dateObj) return '';

    // If it's already a string in MM-DD-YYYY format, return it
    if (typeof dateObj === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(dateObj)) {
      return dateObj;
    }

    // Convert Date object to MM-DD-YYYY format
    try {
      const date = new Date(dateObj);
      if (isNaN(date.getTime())) return '';

      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();
      return `${month}-${day}-${year}`;
    } catch (error) {
      console.error('Error formatting date:', error);
      return '';
    }
  };

  // Handler for updating location
  handleLocationChange = value => {
    this.setState(this.updateAllLocationStates(value), () => {
      this.handleAll();
    });
  };
  // Handler for updating date range
  handleDateChange = () => {
    this.setState(
      {
        defaultBenchmarkValue: this.props.defaultDateValue,
        dashboardDate: this.props.defaultDateValue,
        costDate: this.props.defaultDateValue,
        defaultCostValue: this.props.defaultDateValue,
        budgetDate: this.props.defaultDateValue,
        benchmarkDate: this.props.defaultDateValue,
      },
      () => {
        this.handleAll();
      }
    );
  };

  handleBenchmarkDate = value => {
    var fromDate =
      (value[0].getMonth() > 8
        ? value[0].getMonth() + 1
        : '0' + (value[0].getMonth() + 1)) +
      '-' +
      (value[0].getDate() > 9 ? value[0].getDate() : '0' + value[0].getDate()) +
      '-' +
      value[0].getFullYear();
    var toDate =
      (value[1].getMonth() > 8
        ? value[1].getMonth() + 1
        : '0' + (value[1].getMonth() + 1)) +
      '-' +
      (value[1].getDate() > 9 ? value[1].getDate() : '0' + value[1].getDate()) +
      '-' +
      value[1].getFullYear();

    var formData = new FormData();
    formData.append('fromDate', fromDate);
    formData.append('toDate', toDate);
    fetchWithAuth('/api/benchmark_data/', {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        if (data.code === undefined) {
          this.setState({
            benchmarkDataTable: data['table'],
            benchmarkOverview: data['overview'],
            defaultBenchmarkValue: value,
          });
        } else {
          alert('Session Expired!.');
          window.open('/');
        }
      })
      .catch(err => console.error(err));
  };

  handleCostsDate = value => {
    // Don't call API if we don't have location data yet
    const hasLocationData =
      this.state.dashboardLocation ||
      this.state.costLocation ||
      this.state.benchmarkLocation;

    if (!hasLocationData) {
      console.log('Skipping costs date fetch - no location data available yet');
      return;
    }

    const fromDate = this.formatDateToMMDDYYYY(value[0]);
    const toDate = this.formatDateToMMDDYYYY(value[1]);
    this.setState({ costsFromDate: fromDate, costsToDate: toDate });
    const formDataCostSum = new FormData();
    formDataCostSum.append('screen', 1);
    formDataCostSum.append('log', '');
    formDataCostSum.append('type', 'summary');
    formDataCostSum.append('fromDate', fromDate);
    formDataCostSum.append('toDate', toDate);
    fetchWithAuth('/api/pltable/', {
      method: 'POST',
      body: formDataCostSum,
    })
      .then(response => response.json())
      .then(data => {
        this.setState({ pltableSum: data['data'] });
        this.setState({ columnsSum: data['columns'] });
        this.setState({ plTableExcel: data['table'] });
      })
      .catch(err => console.error(err));

    //////////////////////////////////////

    var formData = new FormData();
    formData.append('fromDate', fromDate);
    formData.append('toDate', toDate);
    // Include location/integration for this overview request as well
    {
      let location =
        this.state.costLocation || this.state.dashboardLocation || '';
      let integrationId = '';
      if (
        typeof location === 'string' &&
        location.startsWith('INTEGRATION::')
      ) {
        integrationId = location.split('::')[1] || '';
        location = '';
      } else if (typeof location === 'string' && location.includes('|')) {
        const parts = location.split('|');
        if (parts.length > 1) integrationId = parts[1];
      }
      formData.append('location', location || '');
      if (integrationId) formData.append('integration', integrationId);
    }

    fetchWithAuth('/api/overview_data/', {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        this.setState({
          costRevenue: data['revenue'],
          cost: data['expense'],
          costIncome: data['income'],
        }); //, income: data['income'], cost: data['expense'] })        const wlData = data['wlData'
        this.setState({ defaultCostValue: value });
      })
      .catch(err => console.error(err));
  };

  handleOverview = async screen => {
    // Initialize variables for date and location
    let fromDate = '';
    let toDate = '';
    let location = '';

    // Don't call API if we don't have location data yet (prevents IndexError on initial load)
    const hasLocationData =
      this.state.dashboardLocation ||
      this.state.costLocation ||
      this.state.benchmarkLocation;

    if (!hasLocationData) {
      console.log('Skipping overview fetch - no location data available yet');
      return;
    }

    if (screen !== 'all') {
      // Reset data states when not fetching all data
      this.setState({
        revenue: [
          {
            data: [],
            series: [],
            categories: [],
          },
        ],
        expense: [
          {
            data: [],
            series: [],
            categories: [],
          },
        ],
        income: [
          {
            data: [],
            series: [],
            categories: [],
          },
        ],
        costRevenue: { value: 0 },
        costIncome: { value: 0 },
        cost: { value: 0 },
      });

      // Calculate date range
      var value =
        this.props.defaultDateValue !== undefined
          ? this.calenderPropsDateConverter(this.props.defaultDateValue)
          : undefined;

      if (value !== undefined) {
        fromDate =
          (value[0].getMonth() > 8
            ? value[0].getMonth() + 1
            : '0' + (value[0].getMonth() + 1)) +
          '-' +
          (value[0].getDate() > 9
            ? value[0].getDate()
            : '0' + value[0].getDate()) +
          '-' +
          value[0].getFullYear();

        toDate =
          (value[1].getMonth() > 8
            ? value[1].getMonth() + 1
            : '0' + (value[1].getMonth() + 1)) +
          '-' +
          (value[1].getDate() > 9
            ? value[1].getDate()
            : '0' + value[1].getDate()) +
          '-' +
          value[1].getFullYear();
      }

      // Get location for the specific screen
      location = this.state[screen + 'Location'];
      location = location === undefined ? '' : location;
    }

    // Derive integration from the location string if possible
    let integrationId = '';
    if (typeof location === 'string' && location.startsWith('INTEGRATION::')) {
      // Integration-level selection from reskinned dropdown
      integrationId = location.split('::')[1] || '';
      location = '';
    } else if (typeof location === 'string' && location.includes('|')) {
      // Location ddl_value format: some|integrationId|...
      const parts = location.split('|');
      if (parts.length > 1) {
        integrationId = parts[1];
      }
    }

    var formData = new FormData();
    // if (flag) {
    // }

    // Decide whether to use period or date range
    const usePeriod =
      this.props.periodSelect &&
      this.props.periodSwitcher &&
      this.props.periodFrom &&
      this.props.periodTo;

    // Ensure we have dates when not using period (covers 'all' screen case)
    if (!usePeriod) {
      if (!fromDate || !toDate) {
        const dv =
          this.props.defaultDateValue !== undefined
            ? this.calenderPropsDateConverter(this.props.defaultDateValue)
            : undefined;
        if (dv !== undefined) {
          fromDate = this.formatDateToMMDDYYYY(dv[0]);
          toDate = this.formatDateToMMDDYYYY(dv[1]);
        }
      }
      // Final fallback: if dates are still missing, default to last year (365 days)
      if (!fromDate || !toDate) {
        const today = new Date();
        const oneYearAgo = new Date();
        oneYearAgo.setDate(today.getDate() - 365);
        fromDate = this.formatDateToMMDDYYYY(oneYearAgo);
        toDate = this.formatDateToMMDDYYYY(today);
      }
    }

    if (usePeriod) {
      formData.append('periodFrom', this.props.periodFrom);
      formData.append('periodTo', this.props.periodTo);
    } else {
      formData.append('fromDate', fromDate);
      formData.append('toDate', toDate);
    }

    // Include location and/or integration as available
    formData.append('location', location || '');
    if (integrationId) {
      formData.append('integration', integrationId);
    }

    await fetchWithAuth('/api/overview_data/', {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(response => {
        this.setState({ overviewData: response }, () => {
          this.saveOverviewData(this.state.overviewData, screen);
        });
      })
      .catch(err => {
        console.error(err);
        this.setState({ overviewData: [0] });
      });
  };

  profitandLossData = async (fromDate, toDate) => {
    var formData = new FormData();
    formData.append('fromDate', fromDate);
    formData.append('toDate', toDate);
    formData.append('location', '');
    const response = await fetchWithAuth('/api/overview_data/', {
      method: 'POST',
      body: formData,
    });
    return response;
  };

  saveOverviewData = async (data, screen) => {
    if (data !== undefined) {
      if (screen === 'dashboard' || screen === 'all') {
        // Compare new data with existing data before updating state
        const shouldUpdateRevenue = this.shouldUpdateData(
          data['revenue'],
          this.state.revenue
        );
        const shouldUpdateExpense = this.shouldUpdateData(
          data['expense'],
          this.state.expense
        );
        const shouldUpdateIncome = this.shouldUpdateData(
          data['income'],
          this.state.income
        );

        // Only update state if data has actually changed
        if (shouldUpdateRevenue || shouldUpdateExpense || shouldUpdateIncome) {
          this.setState({
            revenue: data['revenue'],
            expense: data['expense'],
            income: data['income'],
          });
        }

        // Compare new wlData with existing wlData before updating state
        const shouldUpdateWlData = this.shouldUpdateData(
          data['wlData'],
          this.state.wlData
        );
        if (shouldUpdateWlData) {
          this.setState({ wlData: data['wlData'] });
        }
      }

      //// cost overview
      if (screen === 'cost' || screen === 'all') {
        // Compare new data with existing data before updating state
        const shouldUpdateCostRevenue = this.shouldUpdateData(
          data['revenue'],
          this.state.costRevenue
        );
        const shouldUpdateCost = this.shouldUpdateData(
          data['expense'],
          this.state.cost
        );
        const shouldUpdateCostIncome = this.shouldUpdateData(
          data['income'],
          this.state.costIncome
        );

        // Only update state if data has actually changed
        if (
          shouldUpdateCostRevenue ||
          shouldUpdateCost ||
          shouldUpdateCostIncome
        ) {
          this.setState({
            costRevenue: data['revenue'],
            cost: data['expense'],
            costIncome: data['income'],
          });
        }
      }
    }
  };

  handleBenchmark = async () => {
    // Don't call API if we don't have location data yet
    const hasLocationData =
      this.state.dashboardLocation ||
      this.state.costLocation ||
      this.state.benchmarkLocation;

    if (!hasLocationData) {
      console.log('Skipping benchmark fetch - no location data available yet');
      return;
    }

    var value =
      this.props.defaultDateValue !== undefined
        ? this.calenderPropsDateConverter(this.props.defaultDateValue)
        : undefined;
    var fromDate =
      value !== undefined
        ? (value[0].getMonth() > 8
            ? value[0].getMonth() + 1
            : '0' + (value[0].getMonth() + 1)) +
          '-' +
          (value[0].getDate() > 9
            ? value[0].getDate()
            : '0' + value[0].getDate()) +
          '-' +
          value[0].getFullYear()
        : '';
    var toDate =
      value !== undefined
        ? (value[1].getMonth() > 8
            ? value[1].getMonth() + 1
            : '0' + (value[1].getMonth() + 1)) +
          '-' +
          (value[1].getDate() > 9
            ? value[1].getDate()
            : '0' + value[1].getDate()) +
          '-' +
          value[1].getFullYear()
        : '';
    var location = this.state.benchmarkLocation;
    location = location === undefined ? '' : location;

    var formData = new FormData();
    formData.append('fromDate', fromDate);
    formData.append('toDate', toDate);
    formData.append('location', location);

    if (this.props.periodSelect && this.props.periodSwitcher) {
      formData.append('periodFrom', this.props.periodFrom);
      formData.append('periodTo', this.props.periodTo);
    }

    await fetchWithAuth('/api/benchmark_data/', {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        if (data.code === undefined) {
          this.setState({
            benchmarkDataTable: data['table'],
            benchmarkOverview: data['overview'],
          });
        } else {
          window.open('/', '_self');
          alert('Session Expired!.');
        }
      })
      .catch(err => {
        console.error(err);
      });
  };

  handleBudget = async () => {
    // Don't call API if we don't have location data yet
    const hasLocationData =
      this.state.dashboardLocation ||
      this.state.costLocation ||
      this.state.budgetLocation;

    if (!hasLocationData) {
      console.log('Skipping budget fetch - no location data available yet');
      return;
    }

    var value =
      this.props.defaultDateValue !== undefined
        ? this.calenderPropsDateConverter(this.props.defaultDateValue)
        : undefined;
    var fromDate =
      value !== undefined
        ? (value[0].getMonth() > 8
            ? value[0].getMonth() + 1
            : '0' + (value[0].getMonth() + 1)) +
          '-' +
          (value[0].getDate() > 9
            ? value[0].getDate()
            : '0' + value[0].getDate()) +
          '-' +
          value[0].getFullYear()
        : '';
    var toDate =
      value !== undefined
        ? (value[1].getMonth() > 8
            ? value[1].getMonth() + 1
            : '0' + (value[1].getMonth() + 1)) +
          '-' +
          (value[1].getDate() > 9
            ? value[1].getDate()
            : '0' + value[1].getDate()) +
          '-' +
          value[1].getFullYear()
        : '';

    var location = this.state.budgetLocation;
    location = location === undefined ? '' : location;
    var formData = new FormData();

    if (this.props.periodSelect && this.props.periodSwitcher) {
      formData.append('periodFrom', this.props.periodFrom);
      formData.append('periodTo', this.props.periodTo);
    } else {
      formData.append('fromDate', fromDate);
      formData.append('toDate', toDate);
    }
    formData.append('location', location);

    await fetchWithAuth('/api/budget_data/', {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        if (data.code === undefined) {
          const budget = data;
          const budgetSeries = [
            {
              name: data['series'][0],
              data: data['data'][0]['total'][0],
            },
            {
              name: data['series'][1],
              data: data['data'][0]['target'][0],
            },
          ];

          const budgetCategories = data['categories'];
          const achievedExpense =
            data['achieved_expense']['actual_expense'][0] === null
              ? 0
              : Number(data['achieved_expense']['actual_expense'][0]);
          const achievedRevenue =
            data['achieved_revenue']['actual_revenue'][0] === null
              ? 0
              : Number(data['achieved_revenue']['actual_revenue'][0]);
          this.setState({
            budget: budget,
            budgetSeries: budgetSeries,
            budgetCategories: budgetCategories,
            budgetTargetExpense:
              Math.round(
                (Number(data['target_expense']['budget_expense'][0]) -
                  achievedExpense) *
                  100
              ) / 100,
            budgetTargetRevenue:
              Math.round(
                (Number(data['target_revenue']['budget_revenue'][0]) -
                  achievedRevenue) *
                  100
              ) / 100,
            budgetAchievedExpense: achievedExpense,
            budgetAchievedRevenue: achievedRevenue,
          });

          //this.setState({ benchmarkDataTable: data['table'], benchmarkOverview: data['overview'] })
        } else {
          window.open('/', '_self');
          alert('Session Expired!.');
        }
      })
      .catch(err => {
        console.error(err);
      });
  };

  handleCorporate = async countryId => {
    const { selectedCountry } = this.state;

    var value =
      this.props.defaultDateValue !== undefined
        ? this.calenderPropsDateConverter(this.props.defaultDateValue)
        : undefined;

    var fromDate =
      value !== undefined
        ? (value[0].getMonth() > 8
            ? value[0].getMonth() + 1
            : '0' + (value[0].getMonth() + 1)) +
          '-' +
          (value[0].getDate() > 9
            ? value[0].getDate()
            : '0' + value[0].getDate()) +
          '-' +
          value[0].getFullYear()
        : '';
    var toDate =
      value !== undefined
        ? (value[1].getMonth() > 8
            ? value[1].getMonth() + 1
            : '0' + (value[1].getMonth() + 1)) +
          '-' +
          (value[1].getDate() > 9
            ? value[1].getDate()
            : '0' + value[1].getDate()) +
          '-' +
          value[1].getFullYear()
        : '';
    var formData = new FormData();

    if (this.props.periodSelect && this.props.periodSwitcher) {
      formData.append('periodFrom', this.props.periodFrom);
      formData.append('periodTo', this.props.periodTo);
    } else {
      formData.append('fromDate', fromDate);
      formData.append('toDate', toDate);
    }
    formData.append('country_id', countryId || selectedCountry || 'GB');

    await fetchWithAuth('/api/corporate_summary/', {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        if (data.code === undefined) {
          const corporateData = data;
          this.setState({
            corporateData: corporateData,
          });
        } else {
          window.open('/', '_self');
          alert('Session Expired!.');
        }
      })
      .catch(err => {
        console.error(err);
      });
  };

  handleCountryChange = event => {
    this.setState({ selectedCountry: event.target.value });
  };

  handleViewButton = countryId => {
    this.setState({ selectedCountry: countryId });
    this.handleCorporate(countryId);
  };

  handleProfitLoss = async () => {
    // Don't call API if we don't have location data yet
    const hasLocationData =
      this.state.dashboardLocation ||
      this.state.costLocation ||
      this.state.benchmarkLocation;

    if (!hasLocationData) {
      console.log(
        'Skipping profit/loss fetch - no location data available yet'
      );
      return;
    }

    // Always use Redux props as source of truth for dates, similar to handleOverview
    // This prevents race conditions where state updates haven't completed yet
    var value =
      this.props.defaultDateValue !== undefined
        ? this.calenderPropsDateConverter(this.props.defaultDateValue)
        : undefined;
    var fromDate =
      value !== undefined ? this.formatDateToMMDDYYYY(value[0]) : '';
    var toDate = value !== undefined ? this.formatDateToMMDDYYYY(value[1]) : '';

    // Update state to keep it in sync (for other uses)
    // Always sync state even if dates are empty to prevent stale values
    this.setState({ costsFromDate: fromDate, costsToDate: toDate });

    var location = this.state.costLocation;
    location = location === undefined ? '' : location;

    var formDataCostSum = new FormData();
    formDataCostSum.append('screen', 1);
    formDataCostSum.append('log', '');
    formDataCostSum.append('type', 'summary');
    formDataCostSum.append('location', location);

    // Use the appropriate date format based on period selection
    if (this.props.periodSelect && this.props.periodSwitcher) {
      formDataCostSum.append('periodFrom', this.props.periodFrom);
      formDataCostSum.append('periodTo', this.props.periodTo);
    } else {
      formDataCostSum.append('fromDate', fromDate);
      formDataCostSum.append('toDate', toDate);
    }

    fetchWithAuth('/api/pltable/', {
      method: 'POST',
      body: formDataCostSum,
    })
      .then(response => response.json())
      .then(data => {
        this.setState({ pltableSum: data['data'] });
        this.setState({ plTableExcel: data['table'] });
        this.setState({ columnsSum: data['columns'] });
      })
      .catch(err => console.error(err));
  };

  handleAll = async () => {
    this.props.setDataLoading(true);
    // Fetch all data in parallel for better performance
    // Use Promise.allSettled to prevent one failure from blocking others
    await Promise.allSettled([
      this.handleBudget(),
      this.handleBenchmark(),
      this.handleProfitLoss(),
      this.handleOverview('dashboard'),
      this.handleOverview('cost'),
    ]);
    this.props.setDataLoading(false);
  };

  componentDidMount = async () => {
    this.props.setDataLoading(true);
    this.setState({ modeMobile: window.screen.width > 500 ? false : true });
    window.screen.width > 500
      ? this.setState({ w: 300 })
      : this.setState({ w: '100%' });
    // Wait for location selector to initialize and set location
    // The location selector will trigger handleAll() once it has data
    // Keep loading state on until that happens
  };

  componentDidUpdate(prevProps) {
    // If the view changes to corporateOverview, call handleCorporate
    if (
      this.props.view === 'corporateOverview' &&
      prevProps.view !== 'corporateOverview'
    ) {
      this.handleCorporate();
    }

    // Check if date values have changed (for dashboard and cost views)
    const dateChanged =
      (this.props.view === 'dashboard' ||
        this.props.view === 'cost' ||
        this.props.view === 'reskinnedCost') &&
      (prevProps.defaultDateValue !== this.props.defaultDateValue ||
        prevProps.periodFrom !== this.props.periodFrom ||
        prevProps.periodTo !== this.props.periodTo ||
        prevProps.periodSwitcher !== this.props.periodSwitcher);

    if (dateChanged) {
      // Date has changed, refetch overview data and P&L table
      this.handleOverview('dashboard');
      this.handleOverview('cost');
      // Refetch P&L table data - now safe because handleProfitLoss uses Redux props
      // as source of truth, preventing race conditions
      this.handleProfitLoss();
    }
  }
  render() {
    return (
      <Flex
        bgColor={
          this.props.flags && this.props.flags.showReskin
            ? '#fff'
            : 'whitesmoke'
        }
        mt={this.props.flags && this.props.flags.showReskin ? 0 : 7}
        width={'100%'}
        height={'100%'}
      >
        <Flex
          direction={'column'}
          p={window.screen.width > 500 ? 5 : 1}
          pt={
            this.props.flags && this.props.flags.showReskin
              ? window.screen.width > 500
                ? 6
                : 1
              : window.screen.width > 500
                ? 5
                : 1
          }
          gap={4}
          width={'100%'}
        >
          {/* filter Flex bar */}
          <Flex>
            {window.screen.width > 500 ? (
              <Flex justifyContents={'center'} flex={1}></Flex>
            ) : (
              <></>
            )}
          </Flex>
          {/*end of filter bar*/}
          {this.props.view === 'dashboard' ? (
            <Dashboard
              wins={this.state.wlData['wins']}
              losses={this.state.wlData['losses']}
              income={this.state.income}
              expense={this.state.expense}
              revenue={this.state.revenue}
              clickThru={this.props.clickThru}
              flags={this.props.flags}
              setLocation={value => {
                this.setState(this.updateAllLocationStates(value), () => {
                  this.handleAll();
                });
              }}
              dateValue={value => {
                // if value has data then user has selected month format
                // if user has selected period format then value will be undefined
                this.setState({
                  defaultBenchmarkValue: this.props.defaultDateValue,
                  dashboardDate: this.props.defaultDateValue,
                  costDate: this.props.defaultDateValue,
                  defaultCostValue: this.props.defaultDateValue,
                  budgetDate: this.props.defaultDateValue,
                  benchmarkDate: this.props.defaultDateValue,
                  ...(size(value) > 0
                    ? {
                        costsFromDate: this.formatDateToMMDDYYYY(value[0]),
                        costsToDate: this.formatDateToMMDDYYYY(value[1]),
                      }
                    : {}),
                });
                // Don't call handleAll() here - let componentDidUpdate handle it
                // after props have been updated with new date values
              }}
              value={this.state.dashboardDate}
              locationValue={this.state.dashboardLocation}
            />
          ) : this.props.view === 'cost' ? (
            <Cost
              pltable={this.state.pltable}
              columns={this.state.columns}
              pltableSum={this.state.pltableSum}
              columnsSum={this.state.columnsSum}
              costRevenue={this.state.costRevenue}
              highlightDesc={this.props.highlightDesc}
              cost={this.state.cost}
              costIncome={this.state.costIncome}
              dateValue={value => {
                this.setState(
                  {
                    defaultBenchmarkValue: this.props.defaultDateValue,
                    dashboardDate: this.props.defaultDateValue,
                    costDate: this.props.defaultDateValue,
                    defaultCostValue: this.props.defaultDateValue,
                    budgetDate: this.props.defaultDateValue,
                    benchmarkDate: this.props.defaultDateValue,
                  },
                  () => {
                    this.handleAll();
                  }
                );
              }}
              value={this.state.defaultCostValue}
              from_date={this.state.costsFromDate}
              to_date={this.state.costsToDate}
              tableData={this.state.plTableExcel}
              setLocation={value => {
                this.setState(this.updateAllLocationStates(value), () => {
                  this.handleAll();
                });
              }}
              locationValue={this.state.costLocation}
            />
          ) : this.props.view === 'benchmark' ? (
            <Benchmark
              table={this.state.benchmarkDataTable}
              overview={this.state.benchmarkOverview}
              clickThru={this.props.clickThru}
              dateValue={value => {
                this.setState(
                  {
                    defaultBenchmarkValue: this.props.defaultDateValue,
                    dashboardDate: this.props.defaultDateValue,
                    costDate: this.props.defaultDateValue,
                    defaultCostValue: this.props.defaultDateValue,
                    budgetDate: this.props.defaultDateValue,
                    benchmarkDate: this.props.defaultDateValue,
                  },
                  () => {
                    this.handleAll();
                  }
                );
              }}
              value={this.state.defaultBenchmarkValue}
              setLocation={value => {
                this.setState(this.updateAllLocationStates(value), () => {
                  this.handleAll();
                });
              }}
              locationValue={this.state.benchmarkLocation}
              callTable={() => {
                this.handleBenchmark();
              }}
            />
          ) : this.props.view === 'budget' ? (
            <Budget
              series={this.state.budgetSeries}
              categories={this.state.budgetCategories}
              targetRevenue={this.state.budgetTargetRevenue}
              targetExpense={this.state.budgetTargetExpense}
              achievedRevenue={this.state.budgetAchievedRevenue}
              achievedExpense={this.state.budgetAchievedExpense}
              clickThru={this.props.clickThru}
              handleLocationChange={this.handleLocationChange}
              handleDateChange={this.handleDateChange}
              location={this.state.budgetLocation}
              dateValue={this.state.dashboardDate}
            />
          ) : this.props.view === 'budgetDashboard' ? (
            <BudgetDashboard
              series={this.state.budgetSeries}
              categories={this.state.budgetCategories}
              targetRevenue={this.state.budgetTargetRevenue}
              targetExpense={this.state.budgetTargetExpense}
              achievedRevenue={this.state.budgetAchievedRevenue}
              achievedExpense={this.state.budgetAchievedExpense}
              clickThru={this.props.clickThru}
              handleLocationChange={this.handleLocationChange}
              handleDateChange={this.handleDateChange}
              location={this.state.budgetLocation}
              dateValue={this.state.dashboardDate}
            />
          ) : this.props.view === 'task' ? (
            <TaskPage />
          ) : this.props.view === 'setting' ? (
            <SettingPage />
          ) : this.props.view === 'UploadData' ? (
            <UploadPage />
          ) : this.props.view === 'Profile' ? (
            <Profile />
          ) : this.props.view === 'excelDat' ? (
            <UploadPage />
          ) : this.props.view === 'locationAnalysis' ? (
            <ComparatorTable
              setLocation={value => {
                this.setState(this.handleMultiSelectLocationChange(value));
              }}
              locationValue={this.getLocationValueForMultiSelect()}
            />
          ) : this.props.view === 'dateAnalysis' ? (
            <DateAnalysis
              setLocation={value => {
                this.setState(this.handleMultiSelectLocationChange(value));
              }}
              locationValue={this.getLocationValueForMultiSelect()}
            />
          ) : this.props.view === 'manageUsers' ? (
            <AuthorisationSettings title={this.props.visibleScreen} />
          ) : this.props.view === 'integrationSettings' ? (
            <HotglueConfig config={getHotglueConfig()}>
              <IntegrationSettingHook />
            </HotglueConfig>
          ) : this.props.view === 'budgetUpdate' ? (
            <SettingBudget />
          ) : this.props.view === 'budgetUpdateDD' ? (
            <SettingBudgetDrillDown />
          ) : this.props.view === 'accountAlias' ? (
            <PLSummarySetting title={this.props?.title} />
          ) : this.props.view === 'roleSetting' ? (
            <DefineRoleSettings />
          ) : this.props.view === 'privilegeSettings' ? (
            <DefinePrivSettings title={this.props?.visibleScreen} />
          ) : this.props.view === 'exclusionSettings' ? (
            <DefineExclusionSettings />
          ) : this.props.view === 'exclusionSettingsNew' ? (
            <DefineExclusionSettingsNew />
          ) : this.props.view === 'aiSummary' ? (
            <AIMonthSummary />
          ) : this.props.view === 'aiSummaryOD' ? (
            <AISummaryOneDemand />
          ) : this.props.view === 'corporateOverview' ? (
            <CorporateSummary
              drillingData={this.state.corporateData}
              selectedCountry={this.state.selectedCountry}
              apiEndpoint={apiEndpoint} // Pass API endpoint as a prop
              dateValue={value => {
                this.setState(
                  {
                    corporateDate: this.props.defaultDateValue,
                  },
                  () => {
                    this.handleCorporate(); // Call to refresh data on date change
                  }
                );
              }}
              value={this.state?.corporateDate}
              handleViewButton={this.handleViewButton}
            />
          ) : this.props.view === 'locationAiMapping' ? (
            <LocationBaseAISummary />
          ) : this.props.view === 'reskinnedCost' ? (
            <ReskinnedCost
              pltableSum={this.state.pltableSum}
              revenue={this.state.costRevenue}
              cost={this.state.cost}
              income={this.state.costIncome}
              locationValue={this.state.costLocation}
              setLocation={value => {
                this.setState(this.updateAllLocationStates(value), () => {
                  this.handleAll();
                });
              }}
              dateValue={(value, fromDate, toDate, periodFrom, periodTo) => {
                // Dispatch Redux actions to update periodFrom/periodTo.
                // Note: Redux state updates are asynchronous; updated props will be received
                // after the store updates and React-Redux triggers a re-render.
                if (periodFrom) {
                  this.props.setPeriodFrom(periodFrom);
                }
                if (periodTo) {
                  this.props.setPeriodTo(periodTo);
                }

                // Update component state using the callback parameters directly
                // instead of this.props which may not have updated yet
                this.setState({
                  // Use the value parameter (date range array) if provided
                  defaultBenchmarkValue: value || this.props.defaultDateValue,
                  dashboardDate: value || this.props.defaultDateValue,
                  costDate: value || this.props.defaultDateValue,
                  defaultCostValue: value || this.props.defaultDateValue,
                  budgetDate: value || this.props.defaultDateValue,
                  benchmarkDate: value || this.props.defaultDateValue,
                  // Store the specific date values if provided
                  costsFromDate:
                    fromDate ||
                    (value ? this.formatDateToMMDDYYYY(value[0]) : '') ||
                    this.state.costsFromDate,
                  costsToDate:
                    toDate ||
                    (value ? this.formatDateToMMDDYYYY(value[1]) : '') ||
                    this.state.costsToDate,
                });
                // Don't call handleProfitLoss here - let componentDidUpdate handle it
                // after Redux state has propagated. This prevents race conditions.
              }}
              value={this.state.dashboardDate}
              profitandLossData={this.profitandLossData}
              highlightDesc={this.props.highlightDesc}
              fromDate={this.state.costsFromDate}
              toDate={this.state.costsToDate}
              periodFrom={this.props.periodFrom}
              periodTo={this.props.periodTo}
              periodSelect={this.props.periodSelect}
            />
          ) : this.props.view === 'reskinnedLocationAnalysis' ? (
            <LocationAnalysis
              setLocation={value => {
                this.setState(this.handleMultiSelectLocationChange(value));
              }}
              locationValue={this.getLocationValueForMultiSelect()}
              fromDate={this.state.costsFromDate}
              toDate={this.state.costsToDate}
              periodFrom={this.props.periodFrom}
              periodTo={this.props.periodTo}
              periodSelect={
                this.props.periodSelect && this.props.periodSwitcher
              }
              dateValue={(value, fromDate, toDate, periodFrom, periodTo) => {
                // Update component state using the callback parameters directly
                // instead of this.props which may not have updated yet
                this.setState({
                  // Use the value parameter (date range array) if provided
                  defaultBenchmarkValue: value || this.props.defaultDateValue,
                  dashboardDate: value || this.props.defaultDateValue,
                  costDate: value || this.props.defaultDateValue,
                  defaultCostValue: value || this.props.defaultDateValue,
                  budgetDate: value || this.props.defaultDateValue,
                  benchmarkDate: value || this.props.defaultDateValue,
                  // Store the specific date values if provided
                  costsFromDate:
                    fromDate ||
                    (value ? this.formatDateToMMDDYYYY(value[0]) : '') ||
                    this.state.costsFromDate,
                  costsToDate:
                    toDate ||
                    (value ? this.formatDateToMMDDYYYY(value[1]) : '') ||
                    this.state.costsToDate,
                });
                // Don't call handleAll() here - LocationAnalysis manages its own data fetching
                // through useEffect. This prevents race conditions.
              }}
              value={this.state.dashboardDate}
            />
          ) : this.props.view === 'reskinnedComparisonOvertime' ? (
            <ComparisonOvertime
              setLocation={value => {
                this.setState(this.handleMultiSelectLocationChange(value));
              }}
              locationValue={this.getLocationValueForMultiSelect()}
              fromDate={this.state.costsFromDate}
              toDate={this.state.costsToDate}
              periodFrom={this.props.periodFrom}
              periodTo={this.props.periodTo}
              periodSelect={this.props.periodSelect}
              dateValue={value => {
                this.setState(
                  {
                    defaultBenchmarkValue: this.props.defaultDateValue,
                    dashboardDate: this.props.defaultDateValue,
                    costDate: this.props.defaultDateValue,
                    defaultCostValue: this.props.defaultDateValue,
                    budgetDate: this.props.defaultDateValue,
                    benchmarkDate: this.props.defaultDateValue,
                    costsFromDate:
                      this.formatDateToMMDDYYYY(
                        this.props.defaultDateValue?.[0]
                      ) || '',
                    costsToDate:
                      this.formatDateToMMDDYYYY(
                        this.props.defaultDateValue?.[1]
                      ) || '',
                  },
                  () => {
                    this.handleAll();
                  }
                );
              }}
              value={this.state.dashboardDate}
            />
          ) : this.props.view === 'reskinnedManageUsers' ? (
            <ManageUsers />
          ) : this.props.view === 'reskinnedAccountAlias' ? (
            <ManageAliasAndClassification
              value={this.state.dashboardDate}
              locationValue={this.state.costLocation}
              setLocation={value => {
                this.setState(this.updateAllLocationStates(value), () => {
                  this.handleAll();
                });
              }}
            />
          ) : this.props.view === 'reskinnedRoleSetting' ? (
            <ManageRoles />
          ) : this.props.view === 'reskinnedPrivilegeSettings' ? (
            <ManagePrivilege />
          ) : this.props.view === 'reskinnedExclusionSettings' ? (
            <ManageExclusions key="manage-exclusions" />
          ) : this.props.view === 'reskinnedBudgetUpdateDD' ? (
            <ManageBudget
              key="manage-budget"
              locationValue={this.state.costLocation}
              setLocation={value => {
                this.setState(this.updateAllLocationStates(value), () => {
                  this.handleAll();
                });
              }}
            />
          ) : this.props.view === 'reskinnedSubscriptionBilling' ? (
            <SubscriptionBilling />
          ) : (
            <></>
          )}
        </Flex>
      </Flex>
    );
  }
}

const mapStateToProps = state => {
  return {
    dateFormat: state.dateFormat.value,
    periodFrom: state.dateFormat.periodFrom,
    periodTo: state.dateFormat.periodTo,
    periodSelect: state.dateFormat.periodSelect,
    periodSwitcher: state.dateFormat.periodSwitcher,
    defaultDateValue: state.dateFormat.defaultDateValue,
  };
};

const mapDispatchToProps = {
  setPeriodFrom,
  setPeriodTo,
  setPeriodSelect,
  setDataLoading,
};

export default connect(mapStateToProps, mapDispatchToProps)(WidgetDrawer);
